import React, { FC, ReactNode, useState } from "react";
import { Menu as MuiMenu, MenuItem } from "@mui/material";
import FeatherIcon from "feather-icons-react";

import Box from "../Box";
import Button from "../Button";

export type MenuOption = {
  id: string | number;
  title: string | ReactNode;
};

interface Dropdown {
  button: {
    title: Button["children"];
    variant?: Button["variant"];
    size?: Button["size"];
    hideEndIcon?: boolean;
  };
  options: MenuOption[];
  onSelect: (option: MenuOption) => void;
  disabled?: boolean;
}

const Dropdown: FC<Dropdown> = ({ button, options, onSelect, disabled }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        variant={button.variant}
        size={button.size}
        onClick={handleClick}
        endIcon={
          button.hideEndIcon ? undefined : <FeatherIcon icon="chevron-down" />
        }
        disabled={disabled}
      >
        {button.title}
      </Button>
      <MuiMenu
        anchorEl={anchorEl}
        open={open}
        slotProps={{ list: { disabledItemsFocusable: true } }}
        onClose={handleClose}
      >
        {options.map((option) => (
          <MenuItem
            key={option.id}
            disabled={disabled}
            onClick={() => {
              onSelect(option);
              handleClose();
            }}
          >
            {option.title}
          </MenuItem>
        ))}
      </MuiMenu>
    </Box>
  );
};

export default Dropdown;
